"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutItemType = void 0;
/*
 * Copyright (c) 2024 MTa VELA. All Rights Reserved.
 *
 * MTa VELA proprietary information: the enclosed materials contain proprietary information of MTa VELA and shall not be
 * disclosed in whole or in any part to any third party or used by any person for any purpose, without written consent
 * of MTa VELA. Duplication of any portion of these materials shall include this notice.
 */
/**
 * The different types of items that can be checked out in the VELA API.
 */
var CheckoutItemType;
(function (CheckoutItemType) {
    CheckoutItemType["LICENSE"] = "LICENSE";
    CheckoutItemType["MTA_KIT"] = "MTA_KIT";
    CheckoutItemType["MASTERCLASS"] = "MASTERCLASS";
})(CheckoutItemType || (exports.CheckoutItemType = CheckoutItemType = {}));
